import type { AttachmentOcrWarningCode } from '@bower/shared';

/**
 * The user-facing line for an OCR run that added text with warnings. Shared by
 * the synchronous Image to Text path (useOcrProcessing) and the background
 * `note:ocr-ready` notification (useNotificationSocket), so both say the same
 * thing about the same warning.
 */
const OCR_WARNING_COPY = {
  structured_analysis_degraded: 'Text was added, but scientific layout analysis was unavailable.',
  figure_crop_failed: 'Text was added, but one or more figures could not be embedded.',
  figure_transcription_unavailable:
    'Text was added, but one or more tables were kept as images because their contents could not be read.',
} as const satisfies Record<AttachmentOcrWarningCode, string>;

const OCR_WARNING_PRIORITY: ReadonlyArray<AttachmentOcrWarningCode> = [
  'structured_analysis_degraded',
  'figure_crop_failed',
  'figure_transcription_unavailable',
];

/** The copy for the highest-priority known warning, or undefined when none. */
export function ocrWarningCopy(warningCodes: ReadonlyArray<string>): string | undefined {
  const code = OCR_WARNING_PRIORITY.find((candidate) => warningCodes.includes(candidate));
  return code ? OCR_WARNING_COPY[code] : undefined;
}
